import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../../../../../components/Box';
import Divider from '../../../../../../components/Divider';
import { Td, Tr } from '../../../../../../components/TableAdvanced';
import Typography from '../../../../../../components/Typography';
import { makeStyles } from '../../../../../../utils/styles';

const useStyles = makeStyles(css => ({
    box: css`
        padding: 0 35px 15px 35px;
    `,
    boxTable: css`
        margin: 0 -35px 0 -35px;
    `,
    boxInfo: css`
        margin-bottom: 15px;
    `,
    divider: css`
        margin-bottom: 15px;
    `
}));

const RowSubComponent = ({ row, rowProps, children, footerContent }) => {
    const { t } = useTranslation()
    const styles = useStyles();

    return (
        <Box
            customStyle={styles.box}
        >
            <Divider />
            <Box
                customStyle={styles.boxTable}
            >
                <Tr
                    {...rowProps}
                >
                    {row.cells.map(cell => {
                        return (
                            <Td {...cell.getCellProps()}>
                                {
                                    cell.column.SubCell &&
                                    cell.render('SubCell', {
                                        value: row.original[cell.column.subAccessor]
                                    })
                                }
                            </Td>
                        )
                    })}
                </Tr>
            </Box>
            {
                row?.original?.comment &&
                <Box
                    customStyle={styles.boxInfo}
                >
                    <Typography as="h3">
                        {t("Dodatkowe informacje")}
                    </Typography>
                    <Typography as="p">
                        {row?.original?.comment}
                    </Typography>
                </Box>
            }
            <Divider customStyle={styles.divider} />
            {children}
            <Box>
                {footerContent}
            </Box>
        </Box>
    );
};

export default RowSubComponent;
